export default __webpack_public_path__ + "static/media/obyte.e94b1538.svg";